import { Component } from '@angular/core';

import '../../prism/prism.js';
import { LanguageSettings } from '../../providers/languageSettings.service';

declare var Prism;

@Component({
  selector: 'app-example-cardless-module',
  templateUrl: './example-cardless-module.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})

/**
 * Class holding the example snippets for Cardless features.
 */
export class ExampleCardlessComponent {
/**
 * SG BLE STATUS CALLBACK CONTENT
 */
  JavaSGBLEStatusCallBackPrism:string;
  JavaSGBLEStatusCallBack:string = 
"SGConnectBLE.addObserver(new SGBleObserver() { \n\
        @Override \n\
        public void update(Enum s) { \n\
            Log.i(\"TAG\",\"onUpdate() Ble: \"+s.name()); \n\
        } \n\
        \n\
        @Override \n\
        public void onError(SGError err){ \n\
            Log.e(\"TAG\",\"onError() BLE\" + err.getErrorType() + \" \"  \n\
                + err.getErrorMessage()); \n\
        } \n\
    }); \n\
    ";

SwiftSGBLEStatusCallBackPrism: string;
SwiftSGBLEStatusCallBack = '\
SGConnectBLE.addObserver(onStateChange: onConnectionStateChange) \n\
\n\
func onConnectionStateChange(state: SGBLEConnectionState, error: SGError?) -> Void{ \n\
  print(\"Connection State: \\(state)\") \n\
  if (state == .error){ \n\
      print(\"Connection error: \\(error!.type)\") \n\
  } \n\
}';



  JavaScriptSGBLEStatusCallBackPrism:string;
  JavaScriptSGBLEStatusCallBack:string = "\
onDeviceReady: function() {\n\
  SGConnectAPIPlugin.addObserver(\"SGBLEConnectionState\", function(state){  \n\
    //\"state\" is a string representing the connection state as declared in the enum \n\
  }, function(error){ \n\
    //\"error\" is a json string and with keys = type, localizedDescription & debugInformation, values are strings \n\
  }); \n\
}";

/**
 * SG PROXIMITY STATUS CALLBACK CONTENT
 */

JavaSGProxStatusCallBackPrism:string;
JavaSGProxStatusCallBack:string = 
"SGConnectBLE.addObserver(new SGProxObserver() { \n\
      @Override \n\
      public void update(Enum s) { \n\
          Log.i(\"TAG\",\"onUpdate() Prox: \"+s.name()); \n\
      } \n\
      \n\
      @Override \n\
      public void onError(SGError err){ \n\
          Log.e(\"TAG\",\"onError() BLE\" + err.getErrorType() + \" \"  \n\
              + err.getErrorMessage()); \n\
      } \n\
  }); \n\
";

SwiftSGProxStatusCallBackPrism: string;
SwiftSGProxStatusCallBack = '\
SGConnectBLE.addObserver(onStateChange: onProximityStateChange) \n\
\n\
func onProximityStateChange(state: SGDeviceProximityState, error: SGError?) -> Void{ \n\
  print(\"Proximity State: \\(state)\") \n\
  if (state == .error){ \n\
      print(\"Proximity error: \\(error!.type)\") \n\
  } \n\
}';

  JavaScriptSGProxStatusCallBackPrism:string;
  JavaScriptSGProxStatusCallBack:string = "\
onDeviceReady: function() {\n\
  SGConnectAPIPlugin.addObserver('SGDeviceProximityState', function(state){  \n\
    //'state' is a string representing the proximity state as declared in the enum \n\
  }, function(error){ \n\
    //'error' is a json string and with keys = type, localizedDescription & debugInformation, values are strings \n\
  }); \n\
}";



/**
 * SG SESSION STATUS CALLBACK CONTENT
 */
  JavaSGSessionStatusCallBackPrism:string;
  JavaSGSessionStatusCallBack:string =
"SGConnectBLE.addObserver(new SGSessionObserver() { \n\
  @Override \n\
  public void update(Enum s) { \n\
      Log.i(\"TAG\",\"onUpdate() Session: \"+s.name()); \n\
      \n\
  } \n\
  \n\
  @Override \n\
  public void onError(SGError err) { \n\
      Log.e(\"TAG\",\"onError() Session \" + err.getErrorType() + \" \" \n\
          + err.getErrorMessage()); \n\
          \n\
  } \n\
});";

SwiftSGSessionStatusCallBackPrism: string;
SwiftSGSessionStatusCallBack = 'SGConnectBLE.addObserver(onStateChange: onSessionStateChange) \n\
\n\
func onSessionStateChange(state: SGPlayerSessionState, error: SGError?) -> Void{ \n\
  print(\"Session State: \\(state)\") \n\
  if (state == .error){ \n\
      print(\"Session error: \\(error!.type)\") \n\
  } \n\
}';


  JavaScriptSGSessionStatusCallBackPrism:string;
  JavaScriptSGSessionStatusCallBack:string = "\
onDeviceReady: function() {\n\
  SGConnectAPIPlugin.addObserver('SGPlayerSessionState', function(state){  \n\
    //'state' is a string representing the user session state as declared in the enum \n\
  }, function(error){ \n\
    //'error' is a json string and with keys = type, localizedDescription & debugInformation, values are strings \n\
  }); \n\
}";





/**
 * SG CONNECT DISCONNECT CONTENT
 */
JavaConnectPrism: string;
JavaConnect = '\nSGConnectBLE.createSession((Activity)this, \"5121111021686\"); //using example card number';

SwiftConnectPrism: string;
SwiftConnect = '\nSGConnectBLE.createSession(withAccountNumber: \"5121111021686\") //using example card number';

JavaScriptConnectPrism: string;
JavaScriptConnect = '\nSGConnectAPIPlugin.createSession(\"5121111021686\"); //using example card number';

JavaDisconnectPrism: string;
JavaDisconnect = '\nSGConnectBLE.endSession();';

SwiftDisconnectPrism: string;
SwiftDisconnect = '\nSGConnectBLE.endSession()';

JavaScriptDisconnectPrism: string;
JavaScriptDisconnect = '\nSGConnectAPIPlugin.endSession();';

  constructor(public languageSettings: LanguageSettings) {
    this.applyPrism();
  }

  applyPrism() {
    this.JavaSGBLEStatusCallBackPrism = Prism.highlight(this.JavaSGBLEStatusCallBack, Prism.languages.java);
    this.JavaSGSessionStatusCallBackPrism = Prism.highlight(this.JavaSGSessionStatusCallBack, Prism.languages.java);
    this.JavaConnectPrism = Prism.highlight(this.JavaConnect, Prism.languages.java);
    this.JavaDisconnectPrism = Prism.highlight(this.JavaDisconnect, Prism.languages.java);
    this.JavaSGProxStatusCallBackPrism = Prism.highlight(this.JavaSGProxStatusCallBack, Prism.languages.java);


    this.SwiftSGBLEStatusCallBackPrism = Prism.highlight(this.SwiftSGBLEStatusCallBack, Prism.languages.swift);
    this.SwiftSGSessionStatusCallBackPrism = Prism.highlight(this.SwiftSGSessionStatusCallBack, Prism.languages.swift);
    this.SwiftConnectPrism = Prism.highlight(this.SwiftConnect, Prism.languages.swift);
    this.SwiftDisconnectPrism = Prism.highlight(this.SwiftDisconnect, Prism.languages.swift);
    this.SwiftSGProxStatusCallBackPrism = Prism.highlight(this.SwiftSGProxStatusCallBack, Prism.languages.swift);


    this.JavaScriptSGBLEStatusCallBackPrism =  Prism.highlight(this.JavaScriptSGBLEStatusCallBack, Prism.languages.javascript);
    this.JavaScriptSGSessionStatusCallBackPrism = Prism.highlight(this.JavaScriptSGSessionStatusCallBack, Prism.languages.javascript);
    this.JavaScriptConnectPrism = Prism.highlight(this.JavaScriptConnect, Prism.languages.javascript);
    this.JavaScriptDisconnectPrism = Prism.highlight(this.JavaScriptDisconnect, Prism.languages.javascript);
    this.JavaScriptSGProxStatusCallBackPrism = Prism.highlight(this.JavaScriptSGProxStatusCallBack, Prism.languages.javascript);
  }

}